/**
 * Owner links (BE-28) — real API. A partner row of GET /api/partners carries its `person` (the team member it is);
 * linking and unlinking are PUT /api/partners/{id}/person (TC admin).
 */

import ApiService from '../api.service';
import { unwrapData } from '../../utils/apiConvert';

// [{ partnerId, userId, fullName, loginEnabled, userRole }] for the partners that are linked to a person.
export const linksFrom = (partners = []) => partners
  .filter((p) => p.userId)
  .map((p) => ({
    partnerId: p.id, userId: p.userId, fullName: p.person?.fullName, loginEnabled: p.person?.loginEnabled, userRole: p.person?.userRole,
  }));

export const partnerPeopleService = {
  link: async (partnerId, userId) => unwrapData(await ApiService.put(`/api/partners/${partnerId}/person`, { user_id: userId })),
  unlink: async (partnerId) => unwrapData(await ApiService.put(`/api/partners/${partnerId}/person`, { user_id: null })),
  // Only when the TC has no active partners: one 100% partner linked to the person.
  setupOwner: async (userId) => unwrapData(await ApiService.post('/api/partners/setup-owner', { user_id: userId })),
};
